import React from 'react';

import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
import { QuickStartEditorHeader } from 'src/components/quick-start';
import { useWalkthroughActive } from 'src/editor';

import { StandardEditorAppBarContent } from './StandardEditorAppBarContent';
import { WalkThroughAppBarContent } from './WalkThroughAppBarContent';

export type ActiveAppBar =
  | 'standard'
  | 'template-quickstart'
  | 'walkthrough'
  | 'workflow-quickstart';

interface EditorAppBarContentProps {
  activeAppBar: ActiveAppBar;
  documentId: UUID;
}

export const activeAppBarVar = makeVar<ActiveAppBar>('standard');

export function useActiveAppBar(): { activeAppBar: ActiveAppBar } {
  const { walkThroughActive } = useWalkthroughActive();
  const reactiveAppBar = useReactiveVar(activeAppBarVar);

  return { activeAppBar: walkThroughActive ? 'walkthrough' : reactiveAppBar };
}

export function EditorAppBarContent({
  activeAppBar,
  documentId,
}: EditorAppBarContentProps): JSX.Element {
  switch (activeAppBar) {
    case 'standard':
      return <StandardEditorAppBarContent documentId={documentId} />;
    case 'template-quickstart':
    case 'workflow-quickstart':
      return <QuickStartEditorHeader activeAppBar={activeAppBar} />;
    case 'walkthrough':
      return <WalkThroughAppBarContent />;
  }
}
